import  { useState } from "react";
import { PictureOutlined } from "@ant-design/icons";

export default function ImgOrIcon({
  src, alt, height = 120, radius = 12, fit = "cover",
}: { src?: string | null; alt: string; height?: number; radius?: number; fit?: "cover"|"contain" }) {
  const [err, setErr] = useState(false);
  if (!src || err) {
    return (
      <div style={{
        height, width:"100%", display:"flex", alignItems:"center",
        justifyContent:"center", fontSize:24, color:"#9aa3ad",
        borderRadius:radius, background:"#f4f6f8",
      }}>
        <PictureOutlined />
      </div>
    );
  }
  return <img alt={alt} src={src} onError={()=>setErr(true)} style={{ height, width:height, objectFit:fit, borderRadius:radius }} />;
}
